const e = (d) => d && ["lg", "md", "sm"].includes(d);
export {
  e as validateFormSize
};
//# sourceMappingURL=highrise.es352.js.map
